// src/components/nationwide/CheckinsList.jsx
import React from "react";
import CheckinCard from "./CheckinCard";
import { Loader } from "lucide-react";

const CheckinsList = ({ checkins, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center justify-center">
          <Loader className="w-6 h-6 animate-spin text-[#1C57A5] mr-2" />
          <span className="text-gray-600">Loading previous submissions...</span>
        </div>
      </div>
    );
  }

  if (!checkins || checkins.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <svg
          className="w-5 h-5 text-[#1C57A5]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="text-lg font-semibold text-gray-900">
          Previous Submissions
        </h3>
        <span className="ml-auto text-sm text-gray-600">
          {checkins.length} submission{checkins.length !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="space-y-3">
        {checkins.map((checkin) => (
          <CheckinCard key={checkin.id} checkin={checkin} />
        ))}
      </div>
    </div>
  );
};

export default CheckinsList;